import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {NzModalService} from 'ng-zorro-antd/modal';
import {AppConfigService} from 'src/app-config.service';
import {GeneralService} from 'src/app/service/general-service';
import {NotificationService} from 'src/app/service/notification.service';
import {TableSelectionAbstract} from 'src/app/shared/component/table/table-selection.abstract';
import {Constant} from 'src/app/shared/constants/constant.class';
import {ShareaService} from 'src/app/service/sharea.service';
import {Title} from '@angular/platform-browser';
import * as moment from 'moment';
import { WarehouseService } from 'src/app/service/warehouse.service';
declare var $: any;
import { DxDataGridComponent } from "devextreme-angular";
import { Workbook } from 'exceljs';
import { DateFormatPipe } from 'src/app/shared/pipe/format-date.pipe';
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";


@Component({
  selector: "app-warehouse-chemical",
  templateUrl: "./warehouse-chemical.component.html",
  styleUrls: ["./warehouse-chemical.component.scss"],
})
export class WarehouseChemicalComponent
  extends TableSelectionAbstract
  implements OnInit
{
  @Input() enableEditChemical: boolean;
  @ViewChild("spreadsheet") detailTable: ElementRef;
  @ViewChild("inputElement", { static: false }) inputElement?: ElementRef;
  datas: any[] = [];
  filterData: any[] = [];
  users: any[] = [];
  inputWarehouseDetails: any[] = [];
  listError: any[] = [];
  listDuplicate: any[] = [];
  chemicals: any[] = [];
  inputUsers: any[] = [];
  formAdd: FormGroup;
  isVisibleAdd = false;
  isVisibleUpdate: boolean;
  searchText: any;
  data: any;
  loading: boolean;
  checkAdd = true;
  page: any;
  pageSize: any;
  defaultPage: any;
  checkDelete = true;
  checkUpdate = true;
  checkDetails = true;
  item: any;
  isVisible = false;
  isLoading: boolean;
  isVisibleChemical: boolean;
  value = "";
  title = "0...";
  enableEdit = true;
  isVisibleViewDetail = false;
  loadingButton: boolean;
  dataView = {
    id: "",
    code: "",
    description: "",
    supplier: "",
    paymentAmount: "",
    chemicalId: "",
  };
  barcodeConfig: any;
  arrBarcodes: any[];
  arrColumnBarcodes: any[];
  suppliers: any[] = [];

  selectedWarehouseId: any;
  warehouses: any[] = [];
  selectedChemical: any;
  dataFullDetail: any;
  currentDate = new Date();
  isWarningExpired = false;
  disableComplete = true;
  isOnlyView = false;
  filterForm: FormGroup
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  constructor(
    public translate: TranslateService,
    private modalService: NzModalService,
    private generalService: GeneralService,
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private configService: AppConfigService,
    private shareaService: ShareaService,
    private titleService: Title,
    private warehouseService: WarehouseService,
    private dateFormatPipe: DateFormatPipe
  ) {
    super("id");
    this.formAdd = this.fb.group({
      id: [null],
      code: [null],
      description: [null],
      supplier: [null],
      paymentAmount: [null],
      chemicalId: [null],
      inputUserId: [null],
    });
    this.filterForm = this.fb.group({
      page: 1,
      pageSize: 10000,
      fromDate: [null],
      toDate: [null],
    })
    this.arrBarcodes = [];
  }

  ngOnInit(): void {
    this.selectedWarehouseId = localStorage.getItem(Constant.WAREHOUSE_ID);
    this.pageSize = this.configService.getConfig().pageSize;
    this.page = this.configService.getConfig().page;
    this.defaultPage = this.configService.getConfig().defaultPage;
    this.get();
    this.getUserName();
    this.getChemicalsList();
    this.getListData();
    this.getListDataFullDetail();
    this.getListSupplier();
    this.barcodeConfig = {
      barCodeWidth: 1,
      barCodeHeight: 15,
      code: "default",
    };
    this.selectedWarehouseId = +localStorage.getItem(Constant.WAREHOUSE_ID);
    // alert(this.selectedWarehouseId);
    this.getUserWarehouses();
    this.initTableHeight(1600);
  }
  get formData() {
    return this.formAdd.controls;
  }

  getUserWarehouses() {
    const userInfo = JSON.parse(localStorage.getItem(Constant.USER_INFO));
    console.log(userInfo);
    this.warehouseService.getWarehousesByUserId(userInfo.id).subscribe(
      (res) => {
        this.warehouses = res;
      },
      (error) => {}
    );
  }

  getListData(doPrint = false) {
    this.loading = true;
    this.generalService.getWarehouseChemical().subscribe(
      (res) => {
        if (res !== null) {
          this.datas = res.data;
          this.filterData = res.data;
          super.setListOfAllData(this.datas);
          this.loading = false;
          if (doPrint) {
            const curItem = this.datas[0];
            this.popupPrintBarcode(curItem);
          }
          console.log("dxGridHeight1", this.dxGridHeight);
        }
        console.log("kho hoa chat", res);
      },
      (error) => {}
    );
  }

  getListDataFullDetail(doPrint = false) {
    this.loading = true;
    this.generalService.getWarehouseChemicalFullDetail().subscribe(
      (res) => {
        if (res !== null) {
          this.dataFullDetail = res.data.map((item) => ({
            ...item,
            isWarningExpired:
              Date.parse(item.expiredDate) -
                Date.parse(this.currentDate.toString()) <
              7947355000,
          }));
        }
        console.log("dataFullDetail", this.dataFullDetail);
      },
      (error) => {}
    );
  }

  getFilterData() {
    const payload = this.filterForm.value;
    this.generalService.getWarehouseChemicalFilter(payload).subscribe(
      (res) => {
        if (res !== null) {
          this.dataFullDetail = res.data.map((item) => ({
            ...item,
            isWarningExpired:
              Date.parse(item.expiredDate) -
                Date.parse(this.currentDate.toString()) >
              7947355000,
          }));
          console.log("dataFilter", res);
        }
      },
      (error) => {}
    );
  }

  doSearch() {
    this.getFilterData();
  }

  get() {
    this.translate.use(this.translate.currentLang).subscribe((data) => {
      this.data = data;
    });
  }

  getChemicalsList() {
    this.generalService.getChemical().subscribe(
      (res) => {
        if (res !== null) {
          this.chemicals = res;
          console.log(this.chemicals);
        }
      },
      (error) => {}
    );
  }
  getListSupplier() {
    this.generalService.getSuppliers().subscribe(
      (res) => {
        if (res !== null) {
          this.suppliers = res;
        }
      },
      (error) => {}
    );
  }
  getUserName() {
    this.generalService.getTaikhoan().subscribe(
      (res) => {
        if (res !== null) {
          this.inputUsers = res;
          this.loading = false;
          super.setListOfAllData(this.datas);
          console.log("getUserName", res);
        }
      },
      (error) => {}
    );
  }

  showModalChemical(data) {
    this.isVisibleChemical = true;
    this.item = data;
    this.chemicals = this.item.chemicallists;
  }

  showConfirm(id): void {
    this.get();
    this.modalService.confirm({
      nzTitle: "Confirm",
      nzContent: "Bạn có muốn xóa hay không?",
      nzOkText: "Đồng ý",
      nzCancelText: "Bỏ qua",
      nzOnOk: () => this.deleteItem(id),
    });
  }

  deleteItem(id) {
    this.generalService.deleteWarehouseImport(id).subscribe(
      (res) => {
        if (res.ret && res.ret[0].code !== 0) {
          this.notificationService.showNotification(
            Constant.ERROR,
            res.ret[0].message
          );
        } else {
          this.notificationService.showNotification(
            Constant.SUCCESS,
            Constant.MESSAGE_DELETE_SUCCESS
          );
          this.getListData();
          this.getListDataFullDetail();
        }
      },
      (error) => {}
    );
  }

  showModalAdd() {
    this.isVisibleAdd = true;
    this.disableComplete = true;
    this.inputWarehouseDetails = [];
    this.formAdd.patchValue({
      id: 0,
      code: "",
      description: "",
      supplier: "",
      paymentAmount: 0,
      chemicalId: 0,
      inputUserId: 0,
    });
    this.addDetailInput();
  }

  showModalUpdate(data) {
    this.enableEdit = true;
    this.isVisibleAdd = true;
    this.item = data;
    this.inputWarehouseDetails = data.inputWarehouseDetails;
    this.formAdd.patchValue({
      id: data.id,
      code: data.code,
      description: data.description,
      supplier: data.supplier,
      paymentAmount: data.paymentAmount,
      chemicalId: data.chemicalId,
    });
  }

  showDetails(data) {
    this.isVisibleViewDetail = true;
    this.item = data;
    this.inputWarehouseDetails = data.inputWarehouseDetails;
    this.dataView = {
      id: data.id,
      code: data.code,
      description: data.description,
      supplier: data.supplier,
      paymentAmount: data.paymentAmount,
      chemicalId: data.chemicalId,
    };
    console.log("showDetails", this.dataView, "data", data);
  }

  handleCancel() {
    this.isVisibleAdd = false;
    this.disableComplete = true;
    this.isOnlyView = false;
  }

  handleCancelView() {
    this.isVisibleViewDetail = false;
  }

  addDetailInput() {
    const item = {
      id: 0,
      chemicalId: 0,
      hdtcnumber: 0,
      amount: 0,
      price: 0,
      totalPrice: 0,
      lotCode: "",
      expiredDate: new Date(),
      madeIn: "",
      serialNumber: "",
      manufacturerCode: "",
      manufacturerProductCode: "",
      batchNumber: "",
      unitSmallest: "",
      packingType: 0,
      chemical: {
        id: "",
        code: "",
        name: "",
        packing: "",
        packingUnit: "",
        packingQuantity: "",
        consumableUnit: "",
        consumableQuota: "",
        unitValue: 0,
        expiringMonth: null,
        inventoryAlert: null,
        chemicalCategoryId: 0,
        enable: true,
        currentAmount: 0,
        categoryId: 0,
        totalUnitOfUsePackage: null,
        supplierId: null,
        expiryDateAfterOpening: null,
        expiryDateAfterInMachine: null,
        expiringDayAlert: null,
        expiringDayAfterOpenAlert: null,
        manufacturerId: null,
        category: null,
        chemicalCategory: null,
        manufacturer: null,
        supplier: null,
        consumableRates: [],
        inputWarehouseDetails: [],
        inventories: [],
        moveFromMachineToMachineDetails: [],
        reInputWarehouseDetails: [],
        warehouseChemicalDetails: [],
        warehouseEvictionDetails: [],
        warehouseExportDetails: [],
        warehouseInventoryChemicals: [],
        warehouseInventoryDetails: [],
        warehouseInventoryResults: [],
      },
    };
    this.inputWarehouseDetails.push(item);
  }

  handleOk(doPrint = false) {
    const formValue = this.formAdd.value;
    this.inputWarehouseDetails.forEach((en) => {
      en.chemicalId = en.chemical.id;
      en.unitTypeText =
        en.unitType === 1 ? en.chemical.packing : en.chemical.packingUnit;
    });
    formValue.inputWarehouseDetails = this.inputWarehouseDetails;
    formValue.wareHouseId = this.selectedWarehouseId;
    this.loadingButton = true;
    if (formValue.id === 0) {
      delete formValue.id;
      console.log(formValue);

      this.generalService.addWarehouseChemical(formValue).subscribe(
        (res) => {
          this.loadingButton = false;
          if (
            res !== null &&
            res !== undefined &&
            res.ret !== null &&
            res.ret !== undefined &&
            res.ret.code !== 0
          ) {
            this.notificationService.showNotification(
              Constant.ERROR,
              res.ret[0].message
            );
            formValue.id = 0;
          } else {
            this.disableComplete = false;
            this.getListData(doPrint);
            this.getListDataFullDetail();
            // this.isVisibleAdd = false;
            this.notificationService.showNotification(
              Constant.SUCCESS,
              Constant.MESSAGE_ADD_SUCCESS
            );
          }
        },
        (error) => {
          this.notificationService.showNotification(
            Constant.ERROR,
            Constant.MESSAGE_SERVICE_ERROR
          );
        }
      );
    } else if (formValue.id == null) {
      this.isVisibleAdd = false;
    } else {
      console.log(formValue);
      this.generalService.updateWarehouseChemical(formValue).subscribe(
        (res) => {
          this.loadingButton = false;
          if (
            res !== null &&
            res !== undefined &&
            res.ret !== null &&
            res.ret !== undefined &&
            res.ret[0].code !== 0
          ) {
            console.log("lỗi sai", res.ret);
            this.notificationService.showNotification(
              Constant.ERROR,
              res.ret[0].message
            );
          } else {
            this.getListData();
            this.getListDataFullDetail();
            // this.isVisibleAdd = false;
            this.notificationService.showNotification(
              Constant.SUCCESS,
              Constant.MESSAGE_UPDATE_SUCCESS
            );
          }
        },
        (error) => {}
      );
    }
  }

  deleteDetail(id) {
    this.inputWarehouseDetails = this.inputWarehouseDetails.filter(
      (en) => en.chemicalId !== id
    );
  }

  getRowIndex = (index, pageIndex, pageSize) =>
    index + 1 + pageSize * (pageIndex - 1);

  calculateTotal(data: any) {
    setTimeout(() => {
      // <<<---using ()=> syntax
      data.totalPrice = data.price * data.amount;
    }, 100);
  }
  calculateTotalRevert(data: any) {
    setTimeout(() => {
      // <<<---using ()=> syntax
      data.price = data.totalPrice / data.amount;
    }, 100);
  }
  popupPrintBarcode(data: any) {
    this.arrColumnBarcodes = [];
    let colCount = 3;
    const titlePrint = data.name;
    this.generalService.getBarCodeInputWarehouse(data.id).subscribe((res) => {
      this.arrBarcodes = res;
      const itemCount = res.length;
      if (itemCount <= colCount) {
        colCount = itemCount;
      }
      let rowCount = Math.floor(res.length / colCount);
      const extendRow = res.length % colCount;
      rowCount += extendRow !== 0 ? 1 : 0;
      console.log("row_col", res.length, rowCount, colCount);
      for (let i = 0; i < rowCount; i++) {
        const rowDatas = [];
        for (let j = 0; j < colCount; j++) {
          console.log(i * colCount + j);
          if (i * colCount + j < res.length) {
            const colData = this.arrBarcodes[i * colCount + j];
            rowDatas.push(colData);
          }
        }
        this.arrColumnBarcodes.push(rowDatas);
      }
      console.log(this.arrColumnBarcodes);
      setTimeout(() => {
        this.doPrint(titlePrint);
      }, 200);
    });
  }
  popupPrintBarcodeChemical(data: any) {
    this.arrColumnBarcodes = [];
    let colCount = 3;
    const titlePrint = data.name;
    this.generalService
      .getBarCodeInputWarehouseChemical(data.id, data.chemicalId)
      .subscribe((res) => {
        this.arrBarcodes = res;
        const itemCount = res.length;
        if (itemCount <= colCount) {
          colCount = itemCount;
        }
        let rowCount = Math.floor(res.length / colCount);
        const extendRow = res.length % colCount;
        rowCount += extendRow !== 0 ? 1 : 0;
        console.log("row_col", res.length, rowCount, colCount);
        for (let i = 0; i < rowCount; i++) {
          const rowDatas = [];
          for (let j = 0; j < colCount; j++) {
            console.log(i * colCount + j);
            if (i * colCount + j < res.length) {
              const colData = this.arrBarcodes[i * colCount + j];
              rowDatas.push(colData);
            }
          }
          this.arrColumnBarcodes.push(rowDatas);
        }
        console.log(this.arrColumnBarcodes);
        setTimeout(() => {
          this.doPrint(titlePrint);
        }, 200);
      });
  }
  doPrint(titlePrint) {
    let popupWin;
    const printContents = document.getElementById("div-barcode").innerHTML;
    // console.log(printContents);
    popupWin = window.open("", "_blank", "top=0,left=0,height=100%,width=auto");
    popupWin.document.open();
    const html = `
        <html>
        <head>
        <title>Mẫu xét nghiệm: ${titlePrint}</title>
        <style type="text/css">
               /* style sheet for "A4" printing */
              @media print and (width: 210cm) and (height: 297cm) {
                   @page {
                      /*margin: 10mm;*/
                   }
              }

              /* style sheet for "letter" printing */
              @media print and (width: 8.5in) and (height: 11in) {
                  @page {
                      /*margin: 1in;*/
                  }
              }

              /* A5 Landscape 2480 x 1748 px*/
              @page {
                  /*size: A5 portrait;*/
                  margin: 0mm;
              }
              body{
                  margin:0;
                  padding:0;
              }
              img, svg{
                width: 100%;
              }
          </style>
        </head>
        <body onload='window.print();window.close()'>${printContents}</body>
        </html>`;
    // console.log(html);
    popupWin.document.write(html);
    popupWin.document.close();
  }

  chooseChemical($event: any, data: any) {
    data.unitType = 1;
    this.selectedChemical = data.chemical;
    console.log("id", data.chemical.id);

    // let index = this.inputWarehouseDetails.findIndex((el) => el.id == data.id);
    // this.inputWarehouseDetails[index].chemical = this.chemicals.find(
    //   (el) => el.id == data.chemical.id
    // );
  }

  exportPDF(id) {
    const current_warehouse = this.warehouses.find(
      (en) => en.id === this.selectedWarehouseId
    );
    const phieuId = id;
    const mainUrl =
      this.configService.getConfig().api.reportUrl + "/BridgeXLSDownload.aspx";
    const url =
      mainUrl +
      `?PhieuId=${phieuId}&report=PhieuNhapKho&WarehouseName=${current_warehouse.name}`;
    console.log(url);
    window.open(url, "_blank");
  }

  onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");
    const fileName = `Nhap_kho`;
    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          fileName + ".xlsx"
        );
      });
    });
    e.cancel = true;
  }

  export() {
    this.dataGrid.instance.exportToExcel(false);
  }

  log(data) {
    this.isWarningExpired =
      Date.parse(data.value) - Date.parse(this.currentDate.toString()) <
      7947355000;
  }

  showModalEdit(id) {
    this.disableComplete = false;
    this.isOnlyView = true;
    this.generalService.getWarehouseChemicalById(id).subscribe(
      (res) => {
        if (res !== null) {
          console.log(res);

          this.isVisibleAdd = true;
          this.formAdd.patchValue({
            id: res.id,
            code: res.code,
            description: res.description,
            supplier: res.supplier,
            paymentAmount: res.paymentAmount,
            chemicalId: res.chemicalId,
          });
          this.inputWarehouseDetails = res.inputWarehouseDetails;
        }
      },
      (error) => {}
    );
  }

  handleComplete() {
    this.generalService.completeInput(this.formAdd.value.id).subscribe(
      (res) => {
        if (res.isValid) {
          this.isVisibleAdd = false;
          this.getListDataFullDetail();
          this.notificationService.showNotification(
            Constant.SUCCESS,
            "Đã hoàn thành phiếu nhập kho"
          );
        } else {
          this.notificationService.showNotification(
            Constant.ERROR,
            res.errors[0].key
          );
        }
      },
      (error) => {}
    );
  }
}
